<table #table class="data full-width" [class.isDragging]="!!dragging" tabindex="-1" (keydown)="onKeyDown($event)">
	<thead>
		<tr>
			<th class="lineNum">
			</th>
			<th *ngFor="let header of headers; let index=index">
				<span *ngIf="!headerSwapOptions[index]">{{headerTitles[header]}}</span>
				<button *ngIf="headerSwapOptions[index]" mat-button class="full-width no-padding primary header-title" [matMenuTriggerFor]="headerMenu" [matMenuTriggerData]="{index: index}">
					{{headerTitles[header]}}
					<mat-icon>arrow_drop_down</mat-icon>
				</button>
				<mat-menu #headerMenu="matMenu">
					<ng-template matMenuContent let-index="index">
						<button mat-menu-item *ngFor="let header of headerSwapOptions[index]" (click)="reorderHeaders(index,header)">{{headerTitles[header]}}</button>
					</ng-template>
				</mat-menu>
			</th>
		</tr>
	</thead>
	<tbody>
		<tr *ngFor="let row of paginatedRows;let rowIndex=index;trackBy:trackByLength">
			<td class="lineNum">
				{{rowIndex+1}}
			</td>
			<td *ngFor="let cell of row;let cellIndex=index;trackBy:trackByLength" [class]="cellTypes[rowIndex][cellIndex]" (click)="selectCellEvt($event)">
				<mat-checkbox
					*ngIf="cellTypes[rowIndex][cellIndex]==='boolean'"
					[(ngModel)]="row[cellIndex]"
				></mat-checkbox>
				<input
					*ngIf="cellTypes[rowIndex][cellIndex]==='string'"
					type="text"
					[ngModel]="row[cellIndex]"
					(blur)="onInputBlur($event)"
				/>
				<input
					*ngIf="cellTypes[rowIndex][cellIndex]==='number'"
					type="text"
					[ngModel]="formatNumber(cellIndex,row[cellIndex])"
					(focus)="onInputFocus($event)"
					(blur)="onInputBlur($event)"
				/>
				<div class="drag-handle" (mousedown)="beginDrag($event)"></div>
			</td>
		</tr>
	</tbody>
</table>

<mat-paginator 
	*ngIf="paginate" 
	[length]="rows.length"
	[pageSize]="paginationLength"
	[pageSizeOptions]="[5, 10]"
	aria-label="Select page"
	(page)="getPaginatorData($event)">
</mat-paginator>

